import { ProjectType } from 'nekst-api';

export function useProjectTypeHelper() {
  const orderMap = {
    [ProjectType.PENDING_BUYER]: 0,
    [ProjectType.PENDING_SELLER]: 10,
    [ProjectType.PENDING_DUAL]: 20,

    [ProjectType.LISTING]: 30,
    [ProjectType.ACTIVE_BUYER]: 40,
    [ProjectType.OTHER]: 50,
  };


  const getLabel = (type: ProjectType, inPlural = false) => {
    const map = {
      [ProjectType.LISTING]: inPlural ? 'Listings' : 'Listing',
      [ProjectType.PENDING_BUYER]: inPlural ? 'Pending Buyers' : 'Pending Buyer',
      [ProjectType.PENDING_SELLER]: inPlural ? 'Pending Sellers' : 'Pending Seller',
      [ProjectType.PENDING_DUAL]: inPlural ? 'Pending Duals' : 'Pending Dual',
      [ProjectType.ACTIVE_BUYER]: inPlural ? 'Active Buyers' : 'Active Buyer',
      [ProjectType.OTHER]: 'Other',
    };

    return map[type];
  };

  const compare = (type1: ProjectType, type2: ProjectType) => {
    return orderMap[type1] - orderMap[type2];
  };

  const getTypes = () => {
    return [
      ProjectType.PENDING_BUYER,
      ProjectType.PENDING_SELLER,
      ProjectType.PENDING_DUAL,
      ProjectType.LISTING,
      ProjectType.ACTIVE_BUYER,
      ProjectType.OTHER,
    ];
  };

  return {
    getLabel,
    compare,
    getTypes,
  };
}
